/*eslint-disable*/ export const messages = JSON.parse("{\"toast.aria.error\":[\"Fel\"],\"toast.aria.successful\":[\"Genomfört\"],\"toast.aria.warning\":[\"Varning\"]}");
//# sourceMappingURL=messages.mjs.map